import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
import siderTrigger from './sider-trigger';
import customBreadCrumb from './custom-bread-crumb';
import './header-bar.less';
export default {
  name: 'HeaderBar',
  components: {
    siderTrigger: siderTrigger,
    customBreadCrumb: customBreadCrumb
  },
  props: {
    collapsed: {
      type: Boolean,
      required: true // 确保 collapsed 是必需的

    }
  },
  computed: {
    breadCrumbList: function breadCrumbList() {
      if (this.$route.name === 'detailsNew') {
        var did = this.$route.query.did;
        return [this.$store.state.app.breadCrumbList[0], this.$store.state.app.breadCrumbList[1], _objectSpread({}, this.$store.state.app.breadCrumbList[2], {
          to: '/deviceman/devicedistribution'
        }), {
          icon: '',
          name: did,
          meta: {
            title: did
          }
        }];
      }

      return this.$store.state.app.breadCrumbList;
    },
    icon: function icon() {
      return this.collapsed ? require('./image/open.png') : require('./image/off.png');
    }
  },
  methods: {
    handleCollpasedChange: function handleCollpasedChange(state) {
      this.$emit('on-coll-change', state);
    }
  }
};